<template>
  <div class="app-container">
    <div class="container--header">
      <el-form :model="queryParams" ref="queryForm" :inline="true" size="small">
        
        <el-form-item prop="userCollege">
          <el-select v-model="queryParams.userCollege" placeholder="请选择院系" clearable>
            <el-option v-for="item in collegeOptions" :key="item.collegeId" :label="item.collegeName"
              :value="item.collegeName" :disabled="item.status == 1"></el-option>
          </el-select>
          <!-- <el-input v-model="queryParams.userCollege" placeholder="请输入学院" clearable @clear="bandleClear"></el-input> -->
        </el-form-item>
        <!-- <el-form-item prop="userGrade">
          <el-select v-model="queryParams.userGrade" placeholder="请选择年级" clearable>
            <el-option v-for="(item, index) in gradeOptions" :key="index" :label="item.gradeName" :value="item.gradeName"
              :disabled="item.status == 1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item prop="userGrade">
          <el-input v-model="queryParams.userGrade" placeholder="请输入入学年份,例如：2023" clearable @clear="bandleClear"></el-input>
        </el-form-item>
        <el-form-item prop="userEducation">
          <el-select v-model="queryParams.userEducation" placeholder="请选择硕士或博士" clearable>
            <el-option v-for="(item, index) in educationOptions" :key="index" :label="item.educationName"
              :value="item.educationValue" :disabled="item.status == 1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="userName">
          <el-input v-model="queryParams.userName" placeholder="请输入账号/学号" clearable @clear="bandleClear"></el-input>
        </el-form-item>
        <el-form-item prop="userRealName">
          <el-input v-model="queryParams.userRealName" placeholder="请输入姓名" clearable @clear="bandleClear"></el-input>
        </el-form-item>
        <el-form-item prop="roleCode">
          <el-select v-model="queryParams.roleCode" placeholder="请选择用户角色" clearable>
            <el-option v-for="item in roleOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="bandleReset">重置</el-button>
          <el-button type="primary" @click="getList">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="container--body">
      <vxe-grid ref="xGrid" v-bind="gridOptions" @page-change="pageChange">
        <template #toolbar_buttons>
          <el-button type="primary" size="small" @click="bandleAdd">添加</el-button>
          <el-button type="primary" size="small" @click="downloadTemplateFile">下载导入模板</el-button>
          <el-button type="primary" size="small" @click="bandleImport">批量导入学生数据</el-button>
          <el-button type="primary" size="small" @click="bandleExport" :loading="loadingExport">导出</el-button>
          <el-button type="primary" size="small" @click="bandlePrint">打印</el-button>
        </template>
        <template #actionSlots="scope">
          <el-button type="text" size="mini" @click="bandleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="bandleUnLogin(scope.row)" :disabled="scope.row.error_times < 10">解禁</el-button>
          <el-popconfirm title="确定删除吗？" @confirm="bandleDelUser(scope.row)">
            <el-button slot="reference" type="text" size="mini" style="margin-left: 10px">删除</el-button>
          </el-popconfirm>
        </template>
      </vxe-grid>
    </div>
    <UserModal ref="UserModal" @success="getList" />
  </div>
</template>

<script>
import { listUserPage, delUser, exportListUser, addUserList, updateUser } from '@/api/admin.js';
import { getUser } from "../../utils/auth";
import UserModal from './UserModal.vue';
export default {
  name: 'UserContorl',
  components: { UserModal },
  data() {
    return {
      loading: false,
      queryParams: {
        userName: '',
        userRealName: '',
        userCollege: '',
        userGrade: '',
        userEducation: '',
        roleCode: '',
        page: 1,
        limit: 10,
      },
      total: 0,
      tableData: [],
      loadingExport: false,
      options: [
        {
          value: 'ordinary',
          label: '普通用户'
        },
        {
          value: 'admin',
          label: '院级管理员'
        },
        {
          value: 'root',
          label: '校级管理员'
        }],
      collegeOptions: [{
        collegeId: '0',
        collegeName: '研究生院'
      }, {
        collegeId: '1',
        collegeName: '航空学院'
      },
      {
        collegeId: '2',
        collegeName: '能源与动力学院'
      },
      {
        collegeId: '3',
        collegeName: '自动化学院'
      },
      {
        collegeId: '4',
        collegeName: '电子信息工程学院/集成电路学院'
      },
      {
        collegeId: '5',
        collegeName: '机电学院'
      },
      {
        collegeId: '6',
        collegeName: '材料科学与技术学院'
      },
      {
        collegeId: '7',
        collegeName: '民航学院'
      },
      {
        collegeId: '8',
        collegeName: '数学学院'
      },
      {
        collegeId: '9',
        collegeName: '经济与管理学院'
      },
      {
        collegeId: '10',
        collegeName: '人文与社会科学学院'
      },
      {
        collegeId: '11',
        collegeName: '艺术学院'
      },
      {
        collegeId: '12',
        collegeName: '外国语学院'
      },
      {
        collegeId: '15',
        collegeName: '航天学院'
      },
      {
        collegeId: '16',
        collegeName: '计算机科学与技术学院/人工智能学院/软件学院'
      },
      {
        collegeId: '17',
        collegeName: '马克思主义学院'
      },
      {
        collegeId: '20',
        collegeName: '通用航空与飞行学院'
      },
      {
        collegeId: '21',
        collegeName: '物理学院'
      }],
      educationOptions: [{
        educationValue: 'S',
        educationName: '硕士'
      }, {
        educationValue: 'B',
        educationName: '博士'
      }],
    user: getUser()
  };
},
computed: {
  gridOptions() {
    return {
      size: 'small',
      border: true,
      loading: this.loading,
      height: document.body.clientHeight - 170,
      data: this.tableData,
      columns: [
        // {
        //   field: 'id',
        //   title: 'ID',
        //   width: 300,
        // },
        {
          field: 'user_name',
          title: '账号',
        },
        {
          field: 'user_real_name',
          title: '姓名',
        },
        {
          field: 'user_college',
          title: '学院',
        },
        {
          field: 'user_watch_time',
          title: '学习时长',
        },
        {
          field: 'user_point',
          title: '积分',
        },
        {
          field: 'error_times',
          title: '状态',
          formatter: ({ cellValue }) => {
            return Number(cellValue) >= 10 ? '禁用' : '正常';
          },
        },
        {
          field: 'roleName',
          title: '角色',
          formatter: ({ cellValue }) => {
            return cellValue == null ? '普通用户' : cellValue;
          },
        },
        {
          field: 'action',
          title: '操作',
          fixed: 'right',
          slots: {
            default: 'actionSlots',
          },
        },
      ],
      pagerConfig: {
        currentPage: this.queryParams.page,
        pageSize: this.queryParams.limit,
        pageSizes: [5, 10, 15, 20, 50, 100, 200, 500, 1000],
        total: this.total,
        layouts: ['PrevJump', 'PrevPage', 'JumpNumber', 'Sizes', 'NextPage', 'NextJump', 'FullJump', 'Total'],
      },
      toolbarConfig: {
        enabled: true,
        size: 'medium',
        custom: true,
        zoom: true,
        slots: {
          buttons: 'toolbar_buttons',
        },
      },
    };
  },
  roleOptions() {
    console.log(this.user.roleCode)
    if (this.user.roleCode === 'admin') {
      // 如果用户角色为 "院级管理员"，则不包含 "校级管理员" 选项
      return this.options.filter(role => role.value !== 'root')
    } else {
      return this.options
    }
  }
},
created() {
  this.getList();
  // this.generateGradeOptions()
},
methods: {
  /**
   * 生成年级下拉列表选项
   */
  generateGradeOptions() {
    // 获取当前年份(一年级新生入学年份)，若当前月份没有超过6月，仍然按上一年计算
    const currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    if (currentDate.getMonth() < 6) {
      currentYear -= 1;
    }
    // 定义年级名称和对应的起始年份映射关系
    const gradeNameMap = {
      '研一': currentYear,
      '研二': currentYear - 1,
      '研三': currentYear - 2,
      '博一': currentYear,
      '博二': currentYear - 1,
      '博三': currentYear - 2,
      '博四': currentYear - 3,
      '博五': currentYear - 4,
    };

    // 根据映射关系生成 gradeOptions 数组
    const gradeOptions = Object.entries(gradeNameMap).map(([gradeName, startYear]) => ({
      gradeId: String(startYear),
      gradeName: gradeName,
    }));

    console.log('gradeOptions:', gradeOptions);
    this.gradeOptions = gradeOptions
  },
  downloadTemplateFile() {
    const url = 'http://class101.nuaa.edu.cn/nhmooc/template.xlsx';
    const link = document.createElement('a');
    link.href = url;
    link.download = '用户导入模板.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  getList() {
    this.loading = true;
    // console.log(this.queryParams)
    listUserPage(this.queryParams).then(res => {
      this.loading = false;
      console.log("user:", res.data)
      if (res.code == 0) {
        this.total = res.data.totalCount;
        this.tableData = res.data.list;
      }
    });
  },
  bandleReset() {
    this.$refs['queryForm'].resetFields();
    this.queryParams.limit = 10;
    this.queryParams.page = 1;
    this.getList();
  },
  bandleClear() {
    this.queryParams.limit = 10;
    this.queryParams.page = 1;
    this.getList();
  },
  pageChange({ currentPage, pageSize }) {
    this.queryParams.limit = pageSize;
    this.queryParams.page = currentPage;
    this.getList();
  },
  bandleAdd() {
    this.$refs['UserModal'].openModal(true, { isUpdate: false });
  },
  bandleEdit(row) {
    const data = {
      userName: row.user_name,
      userRealName: row.user_real_name,
      userCollege: row.user_college,
      userPass: row.user_pass,
      roleCode: row.roleCode == null ? 'ordinary' : row.roleCode,
      id: row.id,
    };
    this.$refs['UserModal'].openModal(true, { row: data, isUpdate: true });
  },
  bandleDelUser(row) {
    delUser({ id: row.id }).then(res => {
      if (res.code == 0) {
        this.$message.success(res.msg);
        this.getList();
      } else {
        this.$message.error(res.msg);
      }
    });
  },
    async bandleUnLogin(row) {
    const res = await updateUser({ id: row.id, errorTimes: 0 });
    if (res.code == 0) {
      this.getList();
    }
  },
  bandleImport() {
    this.$refs.xGrid.importData({
      remote: true,
      importMethod: this.importMethod,
      types: ['xlsx'],
      modes: ['insert'],
    });
  },
  importMethod({ file }) {
    const formBody = new FormData();
    formBody.append('file', file);
    addUserList(formBody).then(res => {
      if (res.code == 0) {
        this.$message.success(res.msg);
        this.getList();
      } else {
        this.$message.error(res.msg);
      }
    });
  },
  bandlePrint() {
    this.$refs.xGrid.print();
  },
  bandleExport() {
    const data = {
      userName: this.queryParams.userName,
      userRealName: this.queryParams.userRealName,
      userCollege: this.queryParams.userCollege,
      userGrade: this.queryParams.userGrade,
      userEducation: this.queryParams.userEducation
    };
    this.loadingExport = true;
    exportListUser(data).then(res => {
      this.loadingExport = false;
      let blobUrl = window.URL.createObjectURL(res);
      this.download(blobUrl);
    });
  },
  download(blobUrl) {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    if (month < 10) {
      month = '0' + month;
    }
    if (day < 10) {
      day = '0' + day;
    }
    var nowDate = year + '' + month + '' + day;
    const a = document.createElement('a');
    a.style.display = 'none';
    a.download = `用户信息${nowDate}.xls`;
    a.href = blobUrl;
    a.click();
    // document.body.removeChild(a);
  },
  bandleUnImport() {
    window.location.href = '/excel/空模板.xlsx';
  },
},
};
</script>

<style lang="scss" scoped>
.app-container {
  .container--body {
    background-color: #fff;

    .vxe-grid {
      padding: 6px;
    }
  }
}
</style>
